import { Grid, styled, Typography } from '@mui/material'

import Color from '@ecm/ui/element/Color'

export type FormWrapperProps = {
  backgroundColor?: string
  border?: boolean
  children: React.ReactNode
  className?: string
  heading?: React.ReactNode
  maxWidth?: string
  minWidth?: string
  width?: string
}

export const FormWrapper = styled(
  ({ backgroundColor, children, className, heading }: FormWrapperProps) => (
    <Grid
      container
      alignItems="stretch"
      flexDirection="column"
      justifyContent="space-between"
      className={className}
      bgcolor={backgroundColor}
    >
      {heading && (
        <Typography variant="h5" component="h3" margin="0 0 1em 0">
          {heading}
        </Typography>
      )}
      {children}
    </Grid>
  )
)(({ border, maxWidth, minWidth, width }: FormWrapperProps) => ({
  border: border ? `1px solid ${Color.smoke.darkest}` : undefined,
  borderRadius: '0.25em',
  boxSizing: 'border-box',
  margin: '1em',
  maxWidth: maxWidth || '100%',
  minWidth: minWidth,
  padding: '2em',
  width: width || '100%',
}))

export default FormWrapper
